import React from "react";
import { FileText, Download } from "lucide-react";
import SectionHeading from "../ui/SectionHeading";

const resources = [
  {
    title: "Income Tax Guide for Individuals",
    description:
      "A comprehensive guide to personal income tax filing requirements in Bangladesh.",
    downloadUrl: "#",
  },
  {
    title: "Business Tax Planning Checklist",
    description:
      "Essential checklist for businesses to optimize their tax position and avoid common pitfalls.",
    downloadUrl: "#",
  },
  {
    title: "VAT Registration Form Guide",
    description:
      "Step-by-step instructions for completing the VAT registration process correctly.",
    downloadUrl: "#",
  },
  {
    title: "Company Formation Procedure",
    description:
      "Detailed guide to the company incorporation process in Bangladesh.",
    downloadUrl: "#",
  },
  {
    title: "BIDA Application Requirements",
    description:
      "List of documents and procedures required for BIDA registration and approval.",
    downloadUrl: "#",
  },
  {
    title: "Tax Calendar 2025",
    description: "Important tax deadlines and dates for the 2025 fiscal year.",
    downloadUrl: "#",
  },
];

const ResourceDownloads = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Downloadable Resources"
          subtitle="Access our collection of guides, templates, and checklists to help you navigate tax and business matters."
          center
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {resources.map((resource, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-psa-green-100 rounded-lg mb-4">
                <FileText size={24} className="text-psa-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {resource.title}
              </h3>
              <p className="text-gray-600 mb-6">{resource.description}</p>
              <a
                href={resource.downloadUrl}
                className="inline-flex items-center text-psa-green-600 hover:text-psa-green-700 font-medium transition-colors duration-200"
              >
                Download PDF
                <Download size={16} className="ml-2" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourceDownloads;
